import { IStatus } from '../../books/interfaces';

export const Status: IStatus[] = [
  { label: 'Activo', value: 1 },
  { label: 'Inactivo', value: 0 },
];
